import Vue                        from "vue"
import Vuex                       from "vuex"
import ProductClient              from "../http/woo/ProductClient"
import RefinementConfiguration    from "./RefinementConfiguration"
import CustomizationConfiguration from "./CustomizationConfiguration"
import ValidatorFunctions         from "../validation/ValidatorFunctions"

Vue.use(Vuex)

export default new Vuex.Store({
    modules:   {
        refinementConfiguration:    RefinementConfiguration,
        customizationConfiguration: CustomizationConfiguration
    },
    state:     {
        product:                    {},
        productSelectionAttributes: {},
        refinementAttributes:       {},
        customizationPositions:     [],
        amount:                     0
    },
    actions:   {
        loadProduct: function (context) {
            if (ValidatorFunctions.isEmpty(context.state.product)) {
                let url               = new URL(window.location.href)
                let productIdentifier = url.searchParams.get('p_id')

                return (new ProductClient()).getProduct(productIdentifier)
                    .then(product => {
                        context.commit('updateProduct', product)
                        return product
                    });
            }

            return new Promise(resolve => {
                resolve(context.state.product)
            })
        }
    },
    getters:   {
        hasProduct: function (state) {
            return !ValidatorFunctions.isEmpty(state.product)
        }
    },
    mutations: {
        /**
         * Updates the product in the store.
         *
         * @param state
         * @param product
         */
        updateProduct: function (state, product) {
            state.product = product
        },

        /**
         * Updates the attribute tree for the product selection
         *
         * @param state
         * @param {AttributesTree|Object} tree
         */
        updateProductSelectionAttributes: function (state, tree) {
            state.productSelectionAttributes = tree
        },

        /**
         * Updates the attribute tree for the refinement step
         *
         * @param state
         * @param {AttributesTree|Object} tree
         */
        updateRefinementAttributes: function (state, tree) {
            state.refinementAttributes = tree
        },

        /**
         * Updates the attribute tree for the customization attributes
         *
         * @param state
         * @param {Array} positions
         */
        updateCustomizationPositions: function (state, positions) {
            state.refinementAttributes = positions
        },

        /**
         * Add a customization position to the array of available positions
         *
         * @param state
         * @param position
         */
        addCustomizationPosition: function (state, position) {
            state.customizationPositions.push(position)
        },

        updateAmount: function (state, amount) {
            state.amount = amount
        }
    }
});
